import { ListItemKeyword } from "@similarweb/ui-components";

import { createKeywordUrl } from "app/pages/activation/components/HomeSearch/helpers/createKeywordUrl";
import { redirectToUrl } from "app/pages/activation/components/HomeSearch/helpers/redirectToUrl";
import type { OnSearchItemClick } from "app/pages/activation/components/HomeSearch/types";

export const createDefaultKeywordsItem = (keyword: string, onClick?: OnSearchItemClick) => {
    const url = createKeywordUrl(keyword);

    const onItemClick = () => {
        onClick?.(keyword, "popular");

        redirectToUrl(url);
    };

    return (
        <ListItemKeyword
            key={keyword}
            iconName="keywords"
            text={keyword}
            onClick={onItemClick}
        />
    );
};
